import { FaHeart } from "react-icons/fa";
import "./SaveButton.css";

export default function SaveButton({ isSaved, onToggle, tableMode = false }) {
  return (
    <button
      className={`save-button ${tableMode ? "inline-save" : "overlay-save"}`}
      onClick={onToggle}
    >
      <FaHeart
        color={isSaved ? "#e63946" : "#ccc"} // 🔴 red if saved, ⚪ grey if not
        size={tableMode ? 24 : 36}
      />
    </button>
  );
}
